import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import PropTypes from "prop-types"
import { can, VIEW_PROJECTS } from "@src/helpers/authorization"
import TeamAccess from "../../team_access"
import { updateUsersAccess } from "../../../redux/api/project/access"

class Members extends Component {
  render() {
    const { projectID, projectUsers, roleUsers, parentUsers, updateUsersAccess } = this.props
    return (
      <TeamAccess
        label='Project members'
        attachedUsers={projectUsers}
        roleUsers={roleUsers}
        parentUsers={parentUsers}
        updateUsersAccess={(userIDs, callback) => updateUsersAccess(projectID, userIDs, callback)}
      />
    )
  }
}

Members.propTypes = {
  projectID: PropTypes.string.isRequired,
  updateUsersAccess: PropTypes.func.isRequired,
  projectUsers: PropTypes.array,
  roleUsers: PropTypes.array,
}

const mapStateToProps = state => ({
  projectID: state.project.details._id,
  projectUsers: state.project.details.status !== "PENDING" ? state.project.details.users : [],
  roleUsers: state.user.auth.organization_id
    ? state.settings.organizations.members.items.filter(user => can(user, [VIEW_PROJECTS]))
    : [],
  parentUsers: state.project.details?.breadcrumb ? state.project.details.breadcrumb.reduce((acc, folder) => {
    return acc.concat(folder.users || [])
  }, []) : []
})

const mapDispatchToProps = dispatch => ({
  updateUsersAccess: bindActionCreators(updateUsersAccess, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(Members)
